<template>
  <div class="games-table">
    <el-row type="flex" justify="center">
      <el-col :xs="{span: layout.tableWidth.xs}" :sm="{span: layout.tableWidth.sm}" class="game-table">
        <games-table-header :sort="sort"
                            :sortable="sortable"
                            :options="layout.gameHeaderOptions"
                            :sortBy="sortBy"
                            :order="order"
                            v-if="layout.showHeader"
        ></games-table-header>

        <el-row v-for="(game, index) in games"
                :key="`${index + 1}-${game._id}`"
                :class="'game-status-'+ ((game.status || { labels: [] }).labels[0] || 'none')">

          <games-table-row :game="game"
                           :class="showBorders ? 'games-table-row-bordered' : ''"
            :gameIcons="gameIcons"
            :index="index + 1"
            :systemIcons="systemIcons"
            :addStatus="addStatus"
            :addGameEnabled="addGameEnabled"
            :manageGameTagEnabled="manageGameTagEnabled"
            :exploringGameTagEnabled="exploringGameTagEnabled"
            :options="layout.gameRowOptions"
          ></games-table-row>

        </el-row>

        <!-- add the component right after your list -->
        <mugen-scroll :handler="getGames" :should-handle="!loading && !done" v-if="infinityScroll">
          <p v-if="loading"><i class="el-icon-loading"></i> Loading games...</p>
          <p v-if="done && games.length && !loading">No more results</p>
          <p v-if="done && !games.length && !loading">No games found</p>
        </mugen-scroll>

      </el-col>
    </el-row>
  </div>
</template>

<script>
// @ is an alias to /src
import ErrorHandling from '@/utils/error-handling.js'
import MugenScroll from 'vue-mugen-scroll'
import systemShortName from '@/utils/system-short-name.js'

import GamesTableHeader from '@/components/games-table-header'
import GamesTableRow from '@/components/games-table-row'

export default {
  name: 'GamesTable',
  components: {
    MugenScroll,
    GamesTableHeader,
    GamesTableRow
  },
  props: {
    games: {
      type: Array,
      default: function () { return [] }
    },
    user: {
      type: Object,
      default: function () { return {} }
    },
    infinityScroll: {
      default: true
    },
    getGames: {
      default: () => {}
    },
    sort: {
      default: () => {}
    },
    sortable: {
      default: false
    },
    sortBy: {
      default: 'name'
    },
    order: {
      default: 1
    },
    loading: {
      default: false
    },
    done: {
      default: false
    },
    showBorders: {
      default: false
    },
    addGameEnabled: {
      default: false
    },
    isPeaking: {
      default: false
    },
    manageGameTagEnabled: {
      default: false
    },
    exploringGameTagEnabled: {
      default: false
    },
    refreshCacheOnGameEdit: {
      default: false
    },
    gameIcons: {
      type: Object,
      default: function () { return {} }
    },
    systemIcons: {
      type: Object,
      default: function () { return {} }
    },
    onEmit: {
      default: () => {}
    },
    options: {
      type: Object,
      default: function () {
        return {
          tableWidth: {
            xs: 20,
            sm: 20
          },
          showHeader: false,
          gameRowOptions: undefined,
          gameHeaderOptions: undefined
        }
      }
    }
  },
  computed: {
    layout () {
      return {
        showHeader: this.options.showHeader || false,
        tableWidth: Object.assign({ xs: 20, sm: 20 }, this.options.tableWidth || {}),
        gameRowOptions: this.options.gameRowOptions,
        gameHeaderOptions: this.options.gameHeaderOptions
      }
    }
  },
  data () {
    return {
      updatingStatus: false
    }
  },
  mounted () {},
  methods: {
    systemShortName,

    async addStatus (game, toStatus) {
      if (this.updatingStatus || game.updatingStatus) {
        this.$message.error('Already updating status, please wait!')
        return
      }

      const oldStatusLabel = game.status.labels ? game.status.labels[0] : 'none'

      this.updatingStatus = true
      game.updatingStatus = true

      let status = 'none'

      if (game.status.labels && game.status.labels[1]) status = game.status.labels[1]
      else if (game.status.labels && game.status.labels[0]) status = game.status.labels[0]

      if (this.isPeaking) status = 'myGames'
      if (toStatus) status = toStatus

      const res = await this.$http.put(`archives/${game._id}/${status}`)

      if (res.errors && res.errors.length) {
        ErrorHandling(res.errors, 'archive', { handleMessage: this.$message.error })
        this.updatingStatus = false
        game.updatingStatus = false
      } else {
        this.$message.success('Game status updated!')

        if (this.refreshCacheOnGameEdit && this.user && this.user._id) {
          this.$store.commit('systems', { [this.user._id]: false })
          this.$store.commit('games', { [this.user._id]: false })
        }

        if (status === 'remove') {
          this.games = this.games.filter(el => el._id !== game._id)
          if (this.removeGame) this.removeGame(game)
        } else {
          if (!this.isPeaking) game.status = res.list[0]
          else game.inMyGames = true
        }
        this.updatingStatus = false
        game.updatingStatus = false

        if (this.onEmit && !this.isPeaking) {
          this.onEmit({
            from: oldStatusLabel,
            to: status === 'remove' ? 'removed' : game.status.labels[0]
          })
        }
      }
    }
  }
}
</script>
<style lang="scss">
@import '../styles/variables.scss';
.games-table {
  margin-top: 20px;

  .games-table-row-bordered {
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-bottom-color: $main-color-2;
  }
}
</style>
